import { apiRequest } from '@/api'

export const backupApi = {
  list() {
    return apiRequest('/api/backup/list')
  },

  create(name, username) {
    return apiRequest('/api/backup/create', {
      method: 'POST',
      body: { name, username }
    })
  },

  restore(fileName) {
    return apiRequest('/api/backup/restore', {
      method: 'POST',
      body: { fileName }
    })
  },

  delete(fileName) {
    return apiRequest('/api/backup/delete', {
      method: 'POST',
      body: { fileName }
    })
  },

  rename(oldName, newName) {
    return apiRequest('/api/backup/rename', {
      method: 'POST',
      body: { oldName, newName }
    })
  }
}